import { createContext } from "react";
const QuestionBankProvider = createContext();
export default QuestionBankProvider;

